import { MediaType, type Image, type Media, type Video } from './types';

interface Props {
	images: Image[];
	videos?: Video[] | null;
	contentVideos?: Video[] | null;
	showVideos?: boolean;
}
export const useCarouselMedia = ({
	images,
	videos,
	contentVideos,
}: Props): Media[] => {
	if (!images || images?.length === 0) return [];
	if (
		(!videos || videos?.length === 0) &&
		(!contentVideos || contentVideos.length === 0)
	)
		return imagesMapper(images);
	const [firstImage, ...restImages] = images;
	const [firstVideo, ...restVideos] = videos ?? [];
	return [
		...(firstImage ? imagesMapper([firstImage]) : []),
		...(firstVideo ? videosMapper([firstVideo]) : []),
		...imagesMapper(restImages),
		...videosMapper(restVideos, firstImage),
		...(contentVideos?.length !== 0
			? videosMapper(contentVideos, firstImage)
			: []),
	];
};

const imagesMapper = (images?: Image[]): Media[] => {
	return images?.map(({ src }) => ({ type: MediaType.IMAGE, src })) ?? [];
};

const videosMapper = (
	videos: Video[] | null | undefined,
	fallbackThumbnail?: Image,
): Media[] => {
	if (videos) {
		return videos.map(({ original_url, hls_url, thumbnail }) => ({
			type: MediaType.VIDEO,
			src: hls_url || original_url,
			poster: thumbnail ? thumbnail : fallbackThumbnail?.src,
		}));
	} else return [];
};
